import { render, staticRenderFns } from "./edit_userinfo.vue?vue&type=template&id=776fa724&scoped=true&"
import script from "./edit_userinfo.vue?vue&type=script&lang=js&"
export * from "./edit_userinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776fa724",
  null
  
)

export default component.exports